module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av418-15c41b998eb624f6e7ff2f0846385e99.jpg";